import React from "react";
import addProjIcon from "../../Assets/seoimg/add-proj.png";
import AddProject from "../../share/components/add-project-section/map-tracker/AddProject";
import { useTranslation } from "react-i18next";
const AddProjectDialog = () => {
  const { t } = useTranslation();
  return (
    <div className="pllogin-div">
      <div className="add-new-project">
        <div className="project-img">
          <img src={addProjIcon} alt="add-project" />
        </div>
        <div className="pl-con">
          <div>
            <h5>
              {t("rank_tracking.map_rank_tracker.add_first_project.title")}
            </h5>
            <p className="mb-2">
              {t("rank_tracking.map_rank_tracker.add_first_project.des")}{" "}
              <br></br>
              {t("rank_tracking.map_rank_tracker.add_first_project.des2")}
            </p>
            <AddProject />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProjectDialog;
